







































































































































































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { EditorialProject, Element, ElementStatus, ElementType, Milestone, Product, Project, SearchMilestoneOptions, SearchProductOptions, Service } from '@/models'
import { Utils } from '@/utils'
import {
  TYPR_BOOK,
  TYPR_DIGITAL_COURSE,
  TYPR_WEBPACK_COURSE,
  CV_VALUE_CATEGORY_BLOCK,
  CV_VALUE_FULL_CPG,
  TYPR_PACK,
  CV_VALUE_COUNTRY_ES,
  CV_VALUE_TYPE_PROD,
  DEFAULT_ICON_PRODUCT,
  DEFAULT_ICON_ELEMENT_TYPE
} from '@/utils/constants'
import ApiClient from '@/services/api-client'
import { ActionTypes } from '@/store/action-types'
import { CvValueUtils } from '@/utils/cv-value-utils'

@Component({
  components: {
    ListProductServiceModal: () => import('@/components/modals/listProductServiceModal.vue'),
    ProductMetadata: () => import('@/components/ProductMetadata.vue'),
    IndesignFileExample: () => import('@/components/productDetail/IndesignFileExample.vue'),
    RelationToInfo: () => import('@/components/productDetail/RelationToInfo.vue'),
    RelationToListInfo: () => import('@/components/productDetail/RelationToListInfo.vue'),
    ElementStatusFiles: () => import('@/components/productDetail/ElementStatusFiles.vue'),
    EditorialProjectDetailModal: () => import('@/components/modals/editorialProjectDetailModal.vue'),
    ProductDetailModal: () => import('@/components/modals/ProductDetailModal.vue'),
    TypeIcon: () => import('@/components/TypeIcon.vue')
  }
})
export default class DetailTab extends Vue {
  @Prop({ required: true, type: Object }) readonly product: Product
  @Prop({ required: true, type: Object }) readonly digitalCourse: Product
  @Prop({ required: true, type: Array }) elementStatusFiles: ElementStatus[]

  private Utils = Utils
  private CV_VALUE_TYPE_PROD = CV_VALUE_TYPE_PROD

  private relatedToDigitalProducts: Product[] = []
  private fields = [
    { key: 'type', label: `${this.$t('product_detail.table_elements.type')}` },
    { key: 'name', label: `${this.$t('product_detail.table_elements.name')}` },
    { key: 'code', label: `${this.$t('product_detail.table_elements.code')}` },
    { key: 'metadata.startPage', label: `${this.$t('product_detail.table_elements.range')}` },
    { key: 'metadata.fileNameDefault', label: `${this.$t('product_detail.table_elements.indesign')}` },
    { key: 'uuid', label: '' }
  ]

  private milestones: Milestone[] = []
  private services: Service[] = []
  private project: Project = { name: '', code: '', metadata: {}, projectManager: { email: '', firstName: '', lastName: '' } }

  get visibleFields() {
    if (this.product.type === TYPR_DIGITAL_COURSE) {
      return this.fields.filter(item => item.key !== 'metadata.startPage')
    } else {
      return this.fields
    }
  }

  get showCpgUrl() {
    return this.product.type !== TYPR_DIGITAL_COURSE &&
    this.product.type !== TYPR_WEBPACK_COURSE &&
    this.product.type !== TYPR_PACK
  }

  get elementTypes(): ElementType[] {
    return this.$store.getters.elementTypes
  }

  get editorialProjects(): EditorialProject[] {
    return this.$store.getters.editorialProjects
  }

  get isAdmin(): boolean {
    return this.$store.getters.isAdmin
  }

  get isBook() {
    return this.product.type === TYPR_BOOK
  }

  get isDigitalCourse() {
    return this.product.type === TYPR_DIGITAL_COURSE
  }

  get isWebpackCourse() {
    return this.product.type === TYPR_WEBPACK_COURSE
  }

  get isFullCpg() {
    if (!this.product.editorialProjectComplete) {
      return false
    }
    return this.product.editorialProjectComplete.productionMode === CV_VALUE_FULL_CPG
  }

  get showElementFileStatus() {
    return this.elementStatusFiles.length > 0
  }

  created() {
    this.loadServices()
    this.loadProject()
    this.loadElementTypes()
    this.loadTypeProduct()
    this.loadTypeProduct()
    this.loadProductsRelatedToDigital()
    this.loadMilestone()
  }

  private async loadServices() {
    const response = await ApiClient.getProductServices(this.product.code)
    this.services.push(...response)
  }

  private async loadProject() {
    if (this.product.metadata && this.product.metadata.developmentProject) {
      try {
        const response = await ApiClient.getProject(this.product.metadata.developmentProject)
        this.project = Object.assign({}, this.project, response)
      } catch (err) {}
    }
  }

  private async loadMilestone() {
    const searchOptions: SearchMilestoneOptions = {
      productId: parseInt(this.product.id),
      limit: 100
    }
    const result = await ApiClient.searchMilestones(searchOptions)
    this.milestones = result.items
  }

  private async loadProductsRelatedToDigital() {
    const searchOptions: SearchProductOptions = {
      search: '',
      offset: 0,
      limit: 100,
      educationLevel1: null,
      manager: null,
      type: null,
      country: null,
      workType: null,
      subject: null,
      productionCampaign: null,
      editorialProject: null,
      relatedToDigital: this.product.id,
      editorialProjectYearStart: null,
      language: null,
      educationLevel2: null
    }

    ApiClient.searchProducts(searchOptions)
      .then(async(result) => {
        this.relatedToDigitalProducts = result.items
      })
      .catch((e) => {
        console.error('Error loading products', e)
      })
  }

  private showElement(element: Element): Element[] {
    const items: Element[] = []
    for (let i = 0; i < element.elements.length; i++) {
      const subItem = element.elements[i]
      items.push(subItem)
      const elementType = this.elementTypes.find(item => item.codeId === subItem.type)
      if (elementType?.category === CV_VALUE_CATEGORY_BLOCK) {
        items.push(...subItem.elements)
      }
    }
    return items
  }

  private showRangePages(element: Element) {
    if (element.metadata.startPage && element.metadata.endPage) {
      return element.metadata.startPage.padStart(3, '0') + '-' + element.metadata.endPage.padStart(3, '0')
    }
    return ''
  }

  private getCodeToShow(element: Element) {
    return element.integrationCode ? element.integrationCode : element.code
  }

  private generateWwUrl(product: Product) {
    if (product.metadata.wwIssueId && product.metadata.wwBrandId) {
      return `https://es-wwg10.grupo-sm.com/enterprise/studio/#/search/?PublicationId=${product.metadata.wwBrandId}&IssueId=${product.metadata.wwIssueId}`
    } else {
      return ''
    }
  }

  private generateLdxUrl(codsap: string) {
    if (!this.product.country || this.product.country === CV_VALUE_COUNTRY_ES) {
      return `${process.env.VUE_APP_LDX_URL}/projects/${this.product.editorialProject}/course/${codsap}`
    } else {
      return `${process.env.VUE_APP_LDX_LATAM_URL}/projects/${this.product.editorialProject}/course/${codsap}`
    }
  }

  private generateOwncloudUrl(codsap: string) {
    let tenant = 'es'
    if (this.product.country) {
      tenant = this.product.country.split('-')[1]
    }
    return `https://revuela-${tenant}.grupo-sm.com/index.php/apps/files/?dir=/WebPacks/${tenant}/${codsap}`
  }

  private generateAssetsUrl(codsap: string) {
    return `${process.env.VUE_APP_ASSETS_URL}/product/${codsap}`
  }

  private generateFileFolderUrl(product: Product) {
    let editorialProject = product.editorialProjectComplete
    if (!editorialProject) {
      if (this.editorialProjects.length === 0) {
        this.loadEditorialProjects()
      }
      editorialProject = this.editorialProjects.find((item: EditorialProject) => item.id === product.editorialProject)
    }

    if (!editorialProject ||
      !editorialProject.fileRootFolder ||
      !editorialProject.localCode ||
      !product.country ||
      editorialProject.productionMode !== CV_VALUE_FULL_CPG) {
      return ''
    }

    let url = `${process.env.VUE_APP_FUNBOX_URL}/apps/files/?dir=/${editorialProject.fileRootFolder}/${editorialProject.localCode}`
    if (product.metadata.organizationalLevel1) {
      url += `/${product.metadata.organizationalLevel1}`
    }
    if (product.metadata.organizationalLevel2) {
      url += `/${product.metadata.organizationalLevel2}`
    }
    url += `/${product.country?.split('-')[1]}${product.code}`
    return encodeURI(url)
  }

  private getElementTypeName(codeId: string) {
    return Utils.findElementTypeName(codeId, this.$store.getters.elementTypes)
  }

  async loadElementTypes() {
    await this.$store.dispatch(ActionTypes.LOAD_ELEMENT_TYPES)
  }

  private async loadTypeProduct() {
    await CvValueUtils.getCvValuesByType(CV_VALUE_TYPE_PROD)
  }

  private async loadEditorialProjects() {
    await this.$store.dispatch(ActionTypes.LOAD_EDITORIAL_PROJECTS)
  }

  private getCvValueProductIcon(codeId: string) {
    const cvValue = CvValueUtils.getCvValue(codeId, CV_VALUE_TYPE_PROD)
    if (!cvValue || !cvValue.icon) {
      return DEFAULT_ICON_PRODUCT
    }
    return cvValue.icon
  }

  private getElementTypeIcon(type: string) {
    const elementType = this.elementTypes.find((item: ElementType) => item.codeId === type)
    if (!elementType || !elementType.icon) {
      return DEFAULT_ICON_ELEMENT_TYPE
    }
    return elementType.icon
  }

  private getCvValueIcon(codeId: string, type: string) {
    const cvValue = CvValueUtils.getCvValue(codeId, type)
    if (!cvValue) {
      return ''
    }
    return cvValue.icon
  }

  private getLastPartUrl(url: string, level = 1): string | undefined {
    if (!url) {
      return ''
    }
    const parts = url.split('/').filter(Boolean)
    return parts.length >= level ? parts[parts.length - level] : undefined
  }
}
